module.exports = __webpack_public_path__ + "static/media/aiforgood.dd3b82a5.jpg";